/**
 * 큐브로이드 로봇 연결 도우미(2026-10-01) — 그룹 번호 · 로봇 목록 · 되돌리기 스위치
 *
 * 왜: 교실에서 ① 그룹 번호를 안 넣고 연결부터 해서 친구 로봇이 섞이고(이름 앞부분만으로 찾음),
 *     ② 확장을 하나 넣을 때마다 갤러리 → 편집기 → 연결 창을 오가야 했다(직원 2명 같은 불편, 2026-10-01).
 * 그래서: 로봇(큐브로이드 7종)의 연결은 한 창("로봇 연결")에서 — 맨 위에서 그룹 번호를 먼저 확인하고,
 *         모듈마다 [연결]을 차례로 누른다(크롬 규칙상 큐브마다 페어링 창 한 번은 필요).
 * 되돌리기: 브라우저 주소창에서 localStorage.setItem('curoai_robot_panel', '0') 하면 예전 연결 창·그룹 번호 창 그대로.
 *           코드째 되돌리기는 git(이 기능 이전 커밋 b3b6ded).
 */

// 블루투스로 붙는 큐브로이드 로봇 모듈(확장 갤러리 순서)
export const ROBOT_IDS = ['cubroiddcmotor01', 'cubroiddcmotor02', 'cubroidled', 'cubroidmaster', 'cubroidsound', 'cubroidproximity', 'cubroidlighttouch'];
// 메뉴의 "그룹 번호"처럼 특정 모듈 없이 연결 창을 열 때
export const ALL_ROBOTS = '__robots__';
export const isRobot = id => id === ALL_ROBOTS || ROBOT_IDS.indexOf(id) >= 0;

const FLAG = 'curoai_robot_panel';
export const panelEnabled = () => {
    try {
        return window.localStorage.getItem(FLAG) !== '0';
    } catch (e) {
        return true;
    }
};

// 그룹 번호 — 예전 "그룹 번호 설정" 창과 같은 저장 위치·같은 규칙(확장들이 이 값으로 큐브 이름을 거른다: "DC Motor-0012")
const KEY = 'groupNumber';
export const GROUP_EVENT = 'curoai-group-change';
export const getGroup = () => {
    try {
        return window.localStorage.getItem(KEY) || '';
    } catch (e) {
        return '';
    }
};
export const normGroup = v => {
    let s = String(v === null || typeof v === 'undefined' ? '' : v).trim();
    if (/^0{1,4}$/.test(s)) s = '';
    else if (s.length > 0) s = (`0000${s}`).substr(-4);
    return s;
};
export const setGroup = v => {
    const g = normGroup(v);
    try {
        window.localStorage.setItem(KEY, g);
    } catch (e) { /* 막힌 브라우저 — 이번만 */ }
    try {
        window.dispatchEvent(new Event(GROUP_EVENT));
    } catch (e) { /* 옛 브라우저 */ }
    return g;
};

// 0·00·0000 = 그룹 번호가 없는 블록(예전 그룹 번호 창과 같은 규칙: 저장값은 빈 값)
export const isZeroGroup = v => /^0{1,4}$/.test(String(v === null || typeof v === 'undefined' ? '' : v).trim());

// "그룹 번호 없이 연결"을 골랐는지 — 이번 탭 동안 기억한다(2026-10-16 직원 실측: 창을 닫았다 열면 고른 게 사라져
// "그룹 번호를 먼저 입력해 주세요"가 다시 나왔다). 탭을 새로 열면(다음 수업) 다시 묻는다. 번호를 넣으면 지운다.
const NONE = 'curoai_group_none';
export const noGroupChosen = () => {
    try {
        return window.sessionStorage.getItem(NONE) === '1';
    } catch (e) {
        return false;
    }
};
export const setNoGroupChosen = on => {
    try {
        if (on) window.sessionStorage.setItem(NONE, '1');
        else window.sessionStorage.removeItem(NONE);
    } catch (e) { /* 막힌 브라우저 */ }
};

// 이번 탭에서 그룹 번호를 확인했는지 — 공용 PC 에 앞 반 번호가 남아 있으면 연결 전에 "맞나요?"를 묻는다
const CHECKED = 'curoai_group_checked';
export const groupChecked = () => {
    try {
        return window.sessionStorage.getItem(CHECKED) === '1';
    } catch (e) {
        return true;
    }
};
export const markGroupChecked = () => {
    try {
        window.sessionStorage.setItem(CHECKED, '1');
    } catch (e) { /* 막힌 브라우저 */ }
};
